module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc4",
      "id": "dd4"
    }
  }, [_c('i', [_vm._v("January 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "amJanuary2"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0007-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("Sing to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" a new song")]), _vm._v(". ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0007-04-3"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("S")]), _vm._v("ing aloud to God our strength; make a joyful shout to the God of Jacob. Raise a song and strike the timbrel, the pleasant harp with the lute. • He has put a new song in my mouth—praise to our God; many will see it and fear, and will trust in the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-05-6"
    }
  }, [_vm._v("Be strong and of good courage; do not be afraid, nor be dismayed, for the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" your God is with you wherever you go. • The joy of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" is your strength. • Paul . . . thanked God and took courage.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-05-7"
    }
  }, [_vm._v("Knowing the time, that now it is high time to awake out of sleep; for now our salvation is nearer than when we first believed. The night is far spent, the day is at hand. Therefore let us cast off the works of darkness, and let us put on the armor of light. Let us walk properly, as in the day, not in revelry and drunkenness, not in lewdness and lust, not in strife and envy. But put on the Lord Jesus Christ, and make no provision for the flesh, to fulfill its lusts.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 42:10; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 81:1–2; 40:3; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSH")]), _vm._v(". 1:9; N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EH")]), _vm._v(". 8:10; A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CTS")]), _vm._v(" 28:15; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OM")]), _vm._v(". 13:11–14")]), _vm._v(" "), _c('p', {
    staticClass: "txr5",
    attrs: {
      "id": "aeJanuary2"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0007-08-10"
    }
  }, [_c('span', [_c('i', [_vm._v("Let my prayer be set before You as incense, the lifting up of my hands as the evening sacrifice.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0007-09-12"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("Y")]), _vm._v("ou shall make an altar to burn incense on. . . . And you shall put it before the veil that is before the ark of the Testimony, before the mercy seat that is over the Testimony, where I will meet with you. Aaron shall burn on it sweet incense every morning; when he tends the lamps, he shall burn incense on it. And when Aaron lights the lamps at twilight, he shall burn incense on it, a perpetual incense before the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" throughout your generations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-10-15"
    }
  }, [_vm._v("Therefore [Jesus] is also able to save to the uttermost those who come to God through Him, since He always lives to make intercession for them. • The smoke of the incense, with the prayers of the saints, ascended before God from the angel’s hand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-10-17"
    }
  }, [_vm._v("You also, as living stones, are being built up a spiritual house, a holy priesthood, to offer up spiritual sacrifices acceptable to God through Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-10-18"
    }
  }, [_vm._v("Pray without ceasing.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 141:2; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("X")]), _vm._v(". 30:1, 6–8; H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EB")]), _vm._v(". 7:25; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EV")]), _vm._v(". 8:4; 1 P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETER")]), _vm._v(" 2:5; 1 T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HESS")]), _vm._v(". 5:17")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37032b5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter4.vue
// module id = 75
// module chunks = 0